module.exports = __webpack_public_path__ + "img/luchadores.a007e013.jpg";